import { render, staticRenderFns } from "./MenuBoardView.vue?vue&type=template&id=66b71ce5&scoped=true"
import script from "./MenuBoardView.vue?vue&type=script&lang=js"
export * from "./MenuBoardView.vue?vue&type=script&lang=js"
import style0 from "./MenuBoardView.vue?vue&type=style&index=0&id=66b71ce5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b71ce5",
  null
  
)

export default component.exports